export const HOST =
  process.env.NODE_ENV === 'production'
    ? `${window.location.origin}`
    : 'http://localhost:3000';
export const URL_PREFIX = '/mtk';

export const FORM_STATUS = {
  1: 'Черновик',
  2: 'Отправлена',
  6: 'Зарегистрирована',
  90: 'Отозвана',
  139: 'Формальная проверка',
  11: 'Отклонена',
  160: 'Подготовка оферты (договора-счета) на оплату',
  161: 'Направлены оферта (договор) и счет на оплату',
  162: 'Просрочен счет на оплату (оферта отозвана)',
  144: 'Экспертиза проекта',
  145: 'Дополнительный созыв экспертной коллегии',
  148: 'Экспертиза проекта завершена. Проект признан соответствующим требованиям',
  149: 'Экспертиза проекта завершена. Проект признан не соответствующим требованиям',
};

export const REQUEST_TYPE = {
  0: 'Заявка на предварительную экспертизу',
  1: 'Заявка на статус',
  2: 'Заявка на дополнительный проект',
};

export const FORM_LABELS = {
  0: 'primary',
  1: 'success',
  2: 'secondary',
  3: 'warning',
  4: 'secondary',
  5: 'secondary',
  6: 'secondary',
  7: 'secondary',
  8: 'warning',
  9: 'secondary',
  10: 'secondary',
};

export const getFormTitle = ({ process_id }) => 'Заявка №' + process_id;
export const getFormSubtitle = (forms, values) => {
  //not have subtitle
  return '';
};

export const FORM_BUTTONS = {
  send: 'Отправить',
  withdraw: 'Отозвать',
};

export const PAGINATION = {
  page: 1,
  pagesize: 20,
  total: 0,
};
